import React from 'react';

export interface Timer {
    start: () => void;
    stop: () => void;
}

export default function useTimer(duration = 0, callback: any): Timer {
    const timer = React.useRef<number>();

    const start = () => {
        timer.current = window.setTimeout(callback, duration);
    };

    const stop = () => {
        clearTimeout(timer.current);
    };

    return {
        start,
        stop,
    };
}
